import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ce53770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "pt-3 w-100" }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = {
  for: "top-checkbox",
  class: "mt-4 d-flex align-items-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "ms-3" }, "Active", -1))
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "py-5 d-flex justify-content-center align-items-center" }
const _hoisted_9 = { class: "py-5 d-flex justify-content-center align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AvatarUpload = _resolveComponent("AvatarUpload")!
  const _component_TabsDialog = _resolveComponent("TabsDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TabsDialog, {
      modelValue: _ctx.selectedTab,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTab) = $event)),
      title: _ctx.modalTitle,
      opened: _ctx.opened,
      tabs: _ctx.tabs,
      onHide: _ctx.cleanData
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_AppInputsValidationProvider, {
              "shake-tree": _ctx.parentTouched,
              onChangeErrorState: _ctx.onChangeErrorState
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppInput, {
                  id: "new-plan-title",
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  "validation-type": "name",
                  "input-type": "material",
                  type: "text",
                  name: "new-network-title",
                  label: "Title"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_AppInput, {
                    id: "new-plan-type",
                    modelValue: _ctx.planType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.planType) = $event)),
                    "validation-type": "name",
                    "input-type": "material",
                    type: "text",
                    name: "new-network-type",
                    label: "Plan Type"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_AppInput, {
                    id: "new-plan-description",
                    modelValue: _ctx.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                    "validation-type": "name",
                    "input-type": "material",
                    type: "text",
                    name: "new-network-description",
                    label: "Short description"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["shake-tree", "onChangeErrorState"]),
            _createElementVNode("label", _hoisted_5, [
              _createVNode(_component_AppCheckbox, {
                id: "top-checkbox",
                modelValue: _ctx.active,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.active) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AppButton, {
                size: "xl",
                type: "secondary",
                disabled: !_ctx.valid,
                onClick: _ctx.submitHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.modalTitle), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AvatarUpload, {
            size: "42x42",
            format: "PNG",
            title: "Please, upload plan first Icon.",
            direction: "column",
            placeholder: _ctx.icon1,
            onFileChanged: _ctx.uploadFileHandler1
          }, null, 8, ["placeholder", "onFileChanged"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_AvatarUpload, {
            size: "42x42",
            format: "PNG",
            title: "Please, upload plan second Icon.",
            direction: "column",
            placeholder: _ctx.icon2,
            onFileChanged: _ctx.uploadFileHandler2
          }, null, 8, ["placeholder", "onFileChanged"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "opened", "tabs", "onHide"])
  ]))
}